<div class="modal">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">SCRIPT</h4>
        <button class="close" (click)="onCloseModal()"><span style="color: white;">&times;</span></button>
    </div>
      <div class="modal-body">
          <pre>{{parseScriptResponse(scriptResponse) === scriptResponse ? scriptResponse : parseScriptResponse(scriptResponse) | json}}</pre>
      </div>
  </div>
</div>
